import { Flex, Grid, GridItem, Heading } from '@chakra-ui/react';
import React from 'react';
import { Tile } from '@/components/Tile';
import CreateFutureWorkplanButton from '@/components/FutureWorkplan/CreateFutureWorkplanButton';
import SupervisorsTile from '@/components/pages/dashboard/tiles/SupervisorTile/SupervisorsTile';
import { useAssignment } from '@/components/contexts/AssignmentContext/useAssignment';
import LeaveSummary from '@/components/pages/dashboard/tiles/LeaveTile/LeaveSummary';
import AssignmentAllocationsTile from '@/components/pages/dashboard/tiles/ChartTile/AssignmentAllocationsTile';
import InfoTooltip from '@/components/Tooltip/InfoTooltip';
import { dedent } from '@/wpt-lib/utils/stringUtils';
import config from '@/config';

const PlaceholderDashboard = () => {
    const { currentAssignment } = useAssignment();
    const year = new Date().getFullYear();

    const summaryTooltipText = dedent(`The following information relates to your current assignment as indicated in Neo:
    
        My Supervisor: reflects your current manager for this assignment.
        
        Leave: Booked leave is annual leave that has been approved in Ascender Pay.
        
        Workload Allocation: To request an allocation update, you will need to follow internal faculty process and you must have supervisor approval.`);

    return (
        <Grid w={'100%'} templateColumns={'repeat(2, 1fr)'} gap={6} p={6}>
            <Heading as="h2" size={'md'} color={'black'}>
                My Workplans
                <InfoTooltip
                    tooltipLabel={'My Summary Tooltip'}
                    tooltipInfoText={"Please click on the 'Add Workplan' button below to start creating your Workplan."}
                />
            </Heading>
            <Tile colspan={2}>
                <Flex w="100%" alignItems="center" flexWrap="wrap" gap={3}>
                    <CreateFutureWorkplanButton colorScheme="blue" variant="solid" rounded="md" leftIcon={undefined} />
                </Flex>
            </Tile>
            {config.featureFlags.showPlaceholderSummary && (
                <>
                    <GridItem colSpan={2}>
                        <Heading as="h2" size={'md'} color={'black'}>
                            {year} Summary
                            <InfoTooltip tooltipLabel={'My Summary Tooltip'} tooltipInfoText={summaryTooltipText} />
                        </Heading>
                    </GridItem>
                    <GridItem colSpan={{ base: 2, lg: 1 }}>
                        <Grid gap={6} templateRows={'0.5fr 1.5fr'} h={'100%'}>
                            <SupervisorsTile
                                loading={false}
                                error={false}
                                assignment={currentAssignment}
                                supervisors={currentAssignment?.supervisors}
                            />
                            {<LeaveSummary year={year} />}
                        </Grid>
                    </GridItem>
                    <AssignmentAllocationsTile />

                    <GridItem colSpan={2} display="flex" justifyContent="flex-end">
                        <Flex w="fit-content" bgColor="white" p={6} gap={3} mb={6}>
                            <CreateFutureWorkplanButton
                                colorScheme="blue"
                                variant="solid"
                                rounded="md"
                                leftIcon={undefined}
                            />
                        </Flex>
                    </GridItem>
                </>
            )}
        </Grid>
    );
};

export default PlaceholderDashboard;
